import stampQueries from '@apis/queries/stampQueries';
import { useQuery } from '@tanstack/react-query';
import { useAtomValue, useSetAtom } from 'jotai';
import {
    UIEvent, useEffect, useRef, useState,
} from 'react';

import { historyScopeAtom, isChangingAtom, stampCardSorterAtom } from '../../../atoms/stampAtoms';

function useOnScrollCard() {
    const sorter = useAtomValue(stampCardSorterAtom);
    const { data } = useQuery(stampQueries.cardList(sorter));
    const historyScope = useAtomValue(historyScopeAtom);
    const setHistoryScope = useSetAtom(historyScopeAtom);
    const containerRef = useRef<HTMLDivElement>(null);
    const [isScrolling, setIsScrolling] = useState<boolean>(false);
    const isChanging = useAtomValue(isChangingAtom);

    const onScroll = (e: UIEvent<HTMLDivElement>) => {
        if (isChanging) {
            return;
        }
        setIsScrolling(true);
        const { offsetWidth, scrollLeft } = e.currentTarget;
        const index = Math.round(scrollLeft / (offsetWidth - 24));
        const card = data?.cards?.[index];
        if (card) {
            setHistoryScope({
                targetScope: card.targetScope,
                shopId: card.shopId,
                shopGroupId: card.shopGroupId,
            });
        }
    };

    const onScrollEnd = () => {
        setIsScrolling(false);
    };

    // scope가 외부에서 변경되면 해당 카드로 스크롤
    useEffect(() => {
        if (!historyScope || !containerRef.current || !data?.cards || isScrolling) return;
        const index = data.cards.findIndex((card) => {
            if (card.targetScope !== historyScope.targetScope) return false;
            if (historyScope.shopId) return card.shopId === historyScope.shopId;
            if (historyScope.shopGroupId) return card.shopGroupId === historyScope.shopGroupId;
            return true;
        });
        if (index < 0) return;
        const { offsetWidth, scrollLeft } = containerRef.current;
        const target = index * (offsetWidth - 24);
        if (Math.abs(scrollLeft - target) < 1) return;
        containerRef.current.scrollTo({ left: target, behavior: 'smooth' });
    }, [historyScope, data, isScrolling]);

    return { onScroll, containerRef, onScrollEnd };
}

export default useOnScrollCard;
